import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preview-container" }
const _hoisted_2 = {
  class: "preview-frame",
  ref: "preview-frame-container"
}
const _hoisted_3 = { class: "frame-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "frame-container mobile",
  ref: "preview-frame-container-mobile"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("iframe", {
          ref: "preview-frame-desktop",
          id: "preview-frame-desktop",
          src: `${_ctx.frameUrl}?_frame=true`,
          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateScaleDesktop && _ctx.updateScaleDesktop(...args))),
          frameborder: "0"
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("iframe", {
          ref: "preview-frame-mobile",
          id: "preview-frame-mobile",
          src: `${_ctx.frameUrl}?_frame=true&_mobile=true`,
          onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateScaleMobile && _ctx.updateScaleMobile(...args))),
          frameborder: "0"
        }, null, 40, _hoisted_6)
      ], 512)
    ], 512)
  ]))
}